module.exports = __webpack_public_path__ + "img/bg-image-desktop.a0a587a3.svg";